export const GAME_COUNTRY = "country";
export const GAME_NEIGHBOURS = "neighbours";
export const GAME_CAPITAL = "capital";
export const GAME_FLAGS = "flags";
export const GAME_SPOKEN_LANGUAGE = "spokenLanguage";
export const GAME_POPULATION = "population";
export const GAME_CURRENCY = "currency";
export const GAME_POPULOUS_CITIES = "populousCites";
export const GAME_AREA = "area";
